import { http } from "../utils/request";
import { generateSignature } from "../utils/incode";
import { instance } from "../instance";
export const pullAd = (option) => {
    return new Promise(async (resovle, reject) => {
        const timezone = Math.abs(new Date().getTimezoneOffset() / 60);
        const lang = navigator.language;
        const scrnW = window.innerWidth;
        const scrnH = window.innerHeight;
        const country = null;
        const isTgp = instance.isPremium;
        const userId = instance.userId;
        const platform = instance.platform;
        const sdkVer = instance.sdkVer;
        const obj = {
            placeCode: option.placeCode.toString(),
            sdkVer,
            timestamp: Date.now(),
            userId: userId,
        };
        const hash = await generateSignature(`placeCode${obj.placeCode}sdkVer${obj.sdkVer}timestamp${obj.timestamp}userId${obj.userId}`);
        try {
            const data = await http({
                url: "/api/ad/get",
                method: "post",
                data: {
                    ...obj,
                    lang: lang,
                    platform: platform,
                    country,
                    isTgp,
                    scrnW,
                    scrnH,
                    timezone,
                    sign: hash,
                },
            });
            resovle(data.data);
        }
        catch (err) {
            reject(err);
        }
    });
};
var RepoTypeEnum;
(function (RepoTypeEnum) {
    RepoTypeEnum[RepoTypeEnum["view"] = 1] = "view";
    RepoTypeEnum[RepoTypeEnum["exposure"] = 3] = "exposure";
    RepoTypeEnum[RepoTypeEnum["click"] = 5] = "click";
})(RepoTypeEnum || (RepoTypeEnum = {}));
export const repo = async (option) => {
    const timezone = Math.abs(new Date().getTimezoneOffset() / 60);
    const lang = navigator.language;
    const scrnW = window.innerWidth;
    const scrnH = window.innerHeight;
    const country = null;
    const isTgp = instance.isPremium;
    const userId = instance.userId;
    const platform = instance.platform;
    const sdkVer = instance.sdkVer;
    const obj = {
        adUnitId: option.adUnitId,
        placeCode: option.placeCode,
        repoType: RepoTypeEnum[option.repoType],
        sdkVer,
        ssnId: option.ssnId,
        timestamp: Date.now(),
        userId: userId,
    };
    try {
        const hash = await generateSignature(`adUnitId${obj.adUnitId}placeCode${obj.placeCode}repoType${obj.repoType}sdkVer${obj.sdkVer}ssnId${obj.ssnId}timestamp${obj.timestamp}userId${obj.userId}`);
        await http({
            url: "/api/repo/post",
            method: "post",
            data: {
                lang,
                country,
                isTgp,
                scrnW,
                scrnH,
                platform: platform,
                timezone,
                loadTime: option.loadTime,
                sign: hash,
                ...obj,
            },
        });
    }
    catch (err) {
        throw err;
    }
};
//# sourceMappingURL=adAction.js.map